import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./styles/index.scss";

import App from "./App";
import reportWebVitals from "./registerServiceWorker";
import configureStore from "./utils/redux/configureStore";
import ErrorBoundary from "./ErrorBoundary";

const { store, persistor } = configureStore();

const root = createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
